import { CURRENT_LESSON_PAGE } from '../actions/MauthorActions'

export default function currentLessonPage(state = 1, action) {
  switch (action.type) {
    case CURRENT_LESSON_PAGE:
      return action.payload
    default:
      return state
  }
}
